import React, { Component } from 'react';
import DataTable from '../../../../components/DataTable/index';
import PropTypes from 'prop-types';
import $ from 'jquery';
import { STATES } from '../../../../services/constant/constant';
import { Filings } from '../../services/Filings';

class PendingAmendmentsListGrid extends Component {
    constructor(props) {
        super(props);
        this.columns = [
            {
                title: 'Status',
                data: 'filingStatus'
            },
            {
                title: 'Client<br/>Name',
                data: 'clientName'
            },
            {
                title: 'Request<br/>Date',
                data: 'requestDateTime'
            },
            {
                title: 'State',
                data: 'stateId'
            },
            {
                title: 'Trust<br/>Name',
                data: 'trustName'
            },
            {
                title: 'Portfolio<br/>Name',
                data: 'portfolioName'
            },
            {
                title: 'Class<br/>Name',
                data: 'className'
            },
            {
                title: 'Prospectus<br/>Name',
                data: 'prospectusName'
            }
        ];

        this.columnFormat = [
            {
                targets: [0],
                className: 'text-center',
                render: (data, type, full) => {
                    let filingStatusName = Filings.getFilingStatusName(data);
                    return filingStatusName + (full.isSalesReport ? '*' : '');
                },
                createdCell: function(td, cellData, rowData, row, col) {
                    if (rowData.isSalesReport) {
                        td.title = 'In Progress (Sales)';
                    }
                }
            },
            {
                targets: [1],
                createdCell: function(td, cellData, rowData, row, col) {
                    $(td).css('max-width', '165px');
                    td.title = cellData;
                }
            },
            {
                targets: [2],
                className: 'text-center',
                render: function(data, type, full) {
                    if (data) {
                        let date = new Date(data);
                        return date.toLocaleDateString('en-US');
                    }
                }
            },
            {
                targets: [3],
                render: function(data, type, full) {
                    if (data) {
                        return STATES[data].code;
                    }
                },
                createdCell: function(td, cellData, rowData, row, col) {
                    td.title = STATES[cellData].name;
                    $(td).css('width', '3%');
                    $(td).css('text-align', 'center');
                }
            },
            {
                targets: [4, 5, 6, 7],
                orderable: false,
                createdCell: function(td, cellData, rowData, row, col) {
                    $(td).css('max-width', '120px');
                    td.title = cellData;
                }
            }
        ];
    }

    render() {
        let { id, dataList, singleSelection, updateSelected } = this.props;
        return (
            <DataTable
                id={id}
                columns={this.columns}
                data={dataList}
                singleSelection={singleSelection}
                pageable
                searchable
                sortable
                onSelectedItems={data => {
                    updateSelected(data[0]);
                }}
                columnFormat={this.columnFormat}
                rowFormat={(row, data, dataIndex) => {
                    if (singleSelection) {
                        $(row).css('cursor', 'pointer');
                    }
                }}
            />
        );
    }
}

PendingAmendmentsListGrid.propTypes = {
    dataList: PropTypes.array.isRequired
};

PendingAmendmentsListGrid.defaultProps = {
    singleSelection: false
};

export default PendingAmendmentsListGrid;



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/PendingFilings/PendingAmendmentsListGrid.js